export default "/_next/static/videos/fashionhouse_1-229e546c72d937d145e4d35b98b8c05f.mp4";